module.exports = __webpack_public_path__ + "img/nantun-junior-high-school-director.f6ce6b3e.png";